import React from 'react';
import { Card, CardContent, Stack, Typography, Avatar } from '@mui/material';

const StatCard = ({ label, value, icon, helper, color = 'primary' }) => (
  <Card sx={{ height: '100%' }} elevation={0}>
    <CardContent>
      <Stack spacing={2}>
        <Stack direction="row" spacing={2} alignItems="center">
          <Avatar
            sx={{
              bgcolor: `${color}.light`,
              color: `${color}.dark`,
              width: 48,
              height: 48,
            }}
          >
            {icon}
          </Avatar>
          <Stack spacing={0.5}>
            <Typography variant="body2" sx={{ color: 'text.secondary', fontWeight: 600 }}>
              {label}
            </Typography>
            <Typography variant="h4" sx={{ fontWeight: 800 }}>
              {value}
            </Typography>
          </Stack>
        </Stack>
        {helper && (
          <Typography variant="body2" color="text.secondary">
            {helper}
          </Typography>
        )}
      </Stack>
    </CardContent>
  </Card>
);

export default StatCard;
